import { PartialTranslation } from '../translations';

export const mk: PartialTranslation = {
  newChat: 'Нов разговор',
  search: 'Пребарувај',
  user: 'Корисник',
  settings: 'Поставки',
  language: 'Јазик',
  getHelp: 'Добиј помош',
  viewAllPlans: 'Види ги сите планови',
  learnMore: 'Дознај повеќе',
  logOut: 'Излези',
  chooseLanguage: 'Избери јазик',
  chooseYourPreferredLanguage: 'Изберете го вашиот претпочитан јазик',
  searchLanguages: 'Пребарувај јазици...',
  autoDetect: 'Автоматско откривање',
  noLanguagesFound: 'Не се пронајдени јазици',
  askAnything: 'Прашај што сакаш',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Личен',
  freePlan: 'Бесплатен план',
  current: 'Тековен',
  close: 'Затвори',
  archive: 'Архива',
  delete: 'Избриши',
  confirmDelete: 'Дали сте сигурни дека сакате да го избришете овој разговор?',
  confirmArchive: 'Дали сте сигурни дека сакате да го архивирате овој разговор?',
  deleteCannotUndo: 'Ова дејство не може да се отповика.',
  archiveCanFind: 'Можете да го најдете во листата на архивата откако ќе го архивирате.',
  resources: 'Ресурси',
  addResource: 'Додај ресурс',
  deleteResource: 'Избриши ресурс',
  noMatchingResourcesFound: 'Не се пронајдени совпаѓачки ресурси',
  noResourcesAvailable: 'Нема достапни ресурси',
  hideResources: 'Сокриј ресурси',
  showResources: 'Прикажи ресурси',
  typeMessage: 'Внеси порака...',
  thinkingOptions: 'Опции за размислување',
  deleteFile: 'Избриши датотека',
  clearSelection: 'Исчисти избор',
  addAttachment: 'Додај прилог',
  sendMessage: 'Испрати порака',
  deepInsight: 'Длабоко разбирање · Површинска анализа',
  deepInsightDesc: 'Брзо разбирање на клучните точки',
  deepExploration: 'Длабоко истражување · Сеопфатна анализа',
  deepExplorationDesc: 'Повеќедимензионално длабоко истражување',
  deepDeconstruction: 'Длабока деконструкција · Систематски аргумент',
  deepDeconstructionDesc: 'Прогресивна анализа слој по слој',
  contractReview: 'Преглед на договор · Идентификување на ризик',
  contractReviewDesc: 'Аналіз на клаузули и проверка на усогласеност',
  textPolish: 'Полирање текст · Професионален израз',
  textPolishDesc: 'Јазична оптимизација и структурно прилагодување',
  legalDocuments: 'Правни документи · Стандарден нацрт',
  legalDocumentsDesc: 'Професионално пишување правни документи',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Најава',
  register: 'Регистрација',
  welcomeBack: 'Добредојдовте во LawHelper',
  loginSubtitle: 'Вашиот AI асистент за правни истражувања',
  continueWithGoogle: 'Продолжи со Google',
  continueWithMicrosoft: 'Продолжи со Microsoft',
  continueWithWeChat: 'Продолжи со WeChat',
  orContinueWith: 'или продолжи со',
  emailTab: 'Е-пошта',
  phoneTab: 'Телефон',
  emailPlaceholder: 'Внесете ја вашата е-пошта',
  phonePlaceholder: 'Внесете телефонски број',
  codePlaceholder: 'Внесете 6-цифрен код',
  sending: 'Се испраќа...',
  verifying: 'Се потврдува...',
  verify: 'Потврди',
  sendMagicLink: 'Испрати волшебна врска',
  getVerificationCode: 'Добиј код',
  resendCode: 'Повторно испрати код',
  resendIn: 'Повторно испрати за',
  magicLinkSent: 'Волшебна врска е испратена на вашата е-пошта',
  magicLinkHint: 'Ќе испратиме безбедна врска на вашата е-пошта',
  otpSent: 'Кодот за потврда е испратен',
  agreeToTerms: 'Со продолжување се согласувате со нашите',
  privacyPolicy: 'Политика за приватност',
  termsOfService: 'Услови за користење',
  and: 'и',
  privacyTitle: 'Вашата приватност е важна',
  privacyIntro: 'Користиме колачиња и слични технологии за да ви обезбедиме најдобро искуство.',
  essentialCookies: 'Неопходни колачиња',
  essentialDesc: 'Потребни за функционирање на страницата',
  analyticsCookies: 'Аналитички колачиња',
  analyticsDesc: 'Ни помагаат да ја подобриме услугата',
  marketingCookies: 'Маркетинг колачиња',
  marketingDesc: 'Се користат за персонализирана содржина',
  acceptAll: 'Прифати сè',
  essentialOnly: 'Само неопходни',
  customize: 'Прилагоди',
  savePreferences: 'Зачувај поставки',
  back: 'Назад',
  readPrivacyPolicy: 'Прочитајте ја нашата политика за приватност',
  cookiePolicy: 'Политика за колачиња',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI преглед',
  aiDraft: 'AI нацрт',
  smartAssistant: 'Шаблон',

  // 知识库搜索
  enableKnowledgeSearch: 'Овозможи пребарување',
  knowledgeSearchDesc: 'AI пребарува во вашите документи',
  clickToDisable: 'Оневозможи',
  clickToEnable: 'Овозможи',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Затвори панел за ресурси',
  uploading: 'Подигнување на %{fileName}...',
  processing: 'Обработка на %{fileName}...',
  uploadSuccess: '✓ %{fileName} подигнат',
  uploadError: '✗ Неуспешно подигнување: %{error}',
  quickAnswer: 'Брз одговор',
  quickAnswerDesc: 'Брз одговор на едноставни прашања',
  cancelRequest: 'Откажи',
  library: 'Библиотека',
  filterAll: 'Сите',
  filterChat: 'Разговори',
  filterReview: 'Преглед',
  filterDraft: 'Нацрт',
  filterTemplate: 'Шаблон',
  filterForm: 'Формулар',
  thinking: 'Размислувам...',
  thinkingProcess: 'Мисловен процес',
  analyzingLegalLogic: 'Анализа на правна логика...',
  lawhelperThinking: 'Lawhelper размислува...',
  serviceError: 'Грешка во услугата',
  uploaded: 'Подигнато',
  settingsGeneral: 'Општо',
  settingsNotifications: 'Известувања',
  settingsAppearance: 'Изглед',
  settingsProfile: 'Профил',
  settingsResponseNotifications: 'Известувања за одговори',
  settingsResponseNotificationsDesc: 'Известување по завршување на AI одговор',
  settingsColorMode: 'Режим на бои',
  settingsLight: 'Светло',
  settingsDark: 'Темно',
  settingsSystem: 'Систем',
  about: 'За апликацијата',
  reviewTitle: 'Преглед на документ',
  exitReview: 'Излези од преглед',
  uploadPrompt: 'Подигнете PDF за преглед',
  uploadButton: 'Избери датотека',
  startChatConfig: 'Напишете "Прегледај го овој документ"',
  reviewPlaceholder: 'Внесете порака...',
  analyzing: 'Прегледување...',
  reviewComplete: 'Прегледот заврши',
  issuesFound: 'Пронајдени %{count} проблеми',
  draftTitle: 'Изготвување правен документ',
  draftPlaceholder: 'Уредете овде или побарајте од AI...',
  analyzingTemplate: 'Анализа на шаблон %{name}...',
  templateAnalyzed: '✅ Шаблон %{name} анализиран!',
  templateAnalysisPrompt: 'Анализирај клучни клаузули',
  parsingFailed: '⚠️ Неуспешна анализа на датотека.',
  generating: 'Генерирање...',
  generatedSuccess: '✅ Документот е генериран!',
  drafterWelcome: 'Добредојдовте во AI асистент за документи',
  drafterYouCan: 'Можете:',
  drafterUploadTemplate: 'Подигнете шаблон за AI анализа',
  drafterDescribeNeeds: 'Опишете ги барањата',
  drafterLetAiHelp: 'AI помага со договори, спогодби итн.',
  drafterExamples: 'Примери:',
  drafterExampleRental: '"Изгответе договор за закуп"',
  drafterExampleLabor: '"Пополнете договор за вработување"',
  drafterInputPlaceholder: 'Опишете ги потребите...',
  drafterThinking: 'Размислувам...',
  drafterHistoryTitle: 'Историја',
  drafterNoHistory: 'Нема историја',
  drafterNewChat: 'Нов разговор',
  drafterHistory: 'Историја',
  drafterRemoveAttachment: 'Отстрани прилог',
  drafterLineHeight: 'Висина на ред',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Извоз во Word (.docx)',
  drafterExportPdf: 'Извоз во PDF',
  drafterSave: 'Зачувај документ',
  drafterDownload: 'Преземи документ',
  drafterUndo: 'Поништи',
  drafterRedo: 'Повтори',
  drafterBold: 'Задебелено',
  drafterItalic: 'Курзив',
  drafterStrike: 'Прецртано',
  drafterUnderline: 'Подвлечено',
  drafterHighlight: 'Означи',
  drafterLink: 'Вметни линк',
  drafterAlignLeft: 'Лево',
  drafterAlignCenter: 'Центар',
  drafterAlignRight: 'Десно',
  drafterAlignJustify: 'Обострано',
  drafterList: 'Листа',
  drafterBulletList: 'Означена листа',
  drafterOrderedList: 'Нумерирана листа',
  drafterTaskList: 'Листа задачи',
  drafterOpenResource: 'Отвори ресурси',
  drafterStopGeneration: 'Запри генерирање',
  drafterAgentMode: 'Агент режим активен',
  drafterAgentModeOn: 'Агент режим активен',
  drafterAgentModeOff: 'Нормален режим',
  drafterUploadAttachment: 'Подигни прилог',
  drafterExit: 'Излез',
  drafterConfirm: 'Потврди',
  drafterOpenLink: 'Отвори линк',
  drafterDeleteLink: 'Избриши линк',
  drafterQuote: 'Цитат',
  workflowTitle: 'AI процес',
  workflowRunning: 'Се извршува...',
  workflowReady: 'Подготвен',
  workflowCompleted: 'Завршен',
  workflowStartFailed: 'Неуспешно стартување',
  workflowExecutionFailed: 'Неуспешно извршување',
  workflowInterrupted: 'Процесот е прекинат',
  workflowProcessing: 'Обработка...',
  workflowStepsCompleted: 'чекори завршени',
  workflowStepsTotal: 'Процес завршен (%{count} чекори)',
  acceptChanges: 'Прифати промени',
  rejectChanges: 'Одбиј промени',
  changesAccepted: 'Промените се прифатени',
  changesRejected: 'Промените се одбиени',
  stopWorkflow: 'Запри',
  restartWorkflow: 'Рестарт',
  startDrafting: 'Почни изготвување',
  interrupt: 'Запри',
  documentSubject: 'Тема на документ *',
  documentType: 'Тип документ',
  jurisdiction: 'Јурисдикција',
  specialRequirements: 'Посебни барања (опционално)',
  clickStartDrafting: 'Кликнете "Почни изготвување"',
  docTypeContract: 'Договор',
  docTypeAgreement: 'Спогодба',
  docTypeNotice: 'Известување',
  docTypeLetter: 'Писмо',
  docTypePetition: 'Петиција',
  docTypeWill: 'Тестамент',
  docTypePowerOfAttorney: 'Полномошно',
  countryChina: 'Кина',
  countryUSA: 'САД',
  countryGermany: 'Германија',
  countryJapan: 'Јапонија',
  countryFrance: 'Франција',
  countryUK: 'Велика Британија',
  citationVerified: 'Потврдено',
  citationUnverified: 'Непотврдено',
  imageLoadFailed: 'Неуспешно вчитување на слика',
  smartDocTitle: 'Паметен асистент',
  smartDocChatTitle: 'AI асистент за документи',
  smartDocDropPrompt: 'Спуштете PDF тука',
  smartDocSelectFile: 'Избери датотека',
  smartDocOr: 'или',
  smartDocWelcomeTitle: 'Добредојдовте во AI асистент',
  smartDocWelcomeYouCan: 'Можете:',
  smartDocUploadForAI: 'Подигнете шаблон',
  smartDocDescribeDoc: 'Опишете барања',
  smartDocLetAIDraft: 'AI помага со договори',
  smartDocExamples: 'Примери:',
  smartDocExampleRental: '"Изгответе договор за закуп"',
  smartDocExampleLabor: '"Пополнете договор за вработување"',
  smartDocInputPlaceholder: 'Опишете потреби...',
  smartDocRemoveAttachment: 'Отстрани прилог',
  smartDocOpenResources: 'Отвори ресурси',
  smartDocExit: 'Излез',
  reviewStartFailed: 'Неуспешно стартување на преглед',
  reviewFailed: 'Прегледот неуспешен',
  reviewFoundIssues: 'Прегледот заврши, %{count} проблеми.',
  cannotReadStream: 'Не може да се чита токот',
  parseEventFailed: 'Неуспешна анализа на настан',
  errorPrefix: 'Грешка',
  unknownError: 'Непозната грешка',
  file: 'Датотека',
  loading: 'Вчитување...',
  localFolders: 'Локални папки',
  selectLocalFolder: 'Избери локална папка',
  reselectFolder: 'Промени папка',
  addToContext: 'Додај во разговор',
  saveFile: 'Зачувај',
  renameFile: 'Преименувај',
  fileSaved: 'Датотеката е зачувана',
  fileRenamed: 'Датотеката е преименувана во %{name}',
  browserNotSupported: 'Прелистувачот не поддржува пристап до папки',
  noFolderSelected: 'Изберете локална папка',
  scanningFolder: 'Скенирање на папка...',
  selectFileToPreview: 'Изберете датотека за преглед',
  aiAnalyze: 'AI анализа',
};
